import { EnduserFormWizardBody } from "./EnduserFormWizardBody";
import { useFormLinkShallowStore } from "../store";
import type { SurfaceWizardProps } from "./types";

/**
 * The wizard as rendered by the `/link/form` deeplink. Its store persists to the query string, so
 * state survives a copied or reopened link.
 */
export const FormLinkWizard = (props: SurfaceWizardProps) => (
  <EnduserFormWizardBody {...props} useFormShallowStore={useFormLinkShallowStore} />
);
